import { render, staticRenderFns } from "./kontrollera-fallet.vue?vue&type=template&id=2095cc0e&shadow"
import script from "./kontrollera-fallet.vue?vue&type=script&lang=js&shadow"
export * from "./kontrollera-fallet.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./kontrollera-fallet.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports